import { action } from 'easy-peasy';
import { IActionSetBlobUrl } from '../types';

const setBlobUrl: IActionSetBlobUrl = action((state, url) => {
  state.blobUrl = url;
});

export default setBlobUrl;
